import React from "react";

const Concept = () => {
  return (
    <div>
      <p className="step-p"> Click the button to add a peer to the network. </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/add-peer/concept.js